import bbbbBusdCakeLpFarmingPool from "../abis/development/bbbbBusd/pools/bbbbBusd";

const host = "https://bscscan.com/address";
const swapHost = "https://pancakeswap.finance/add";
const pairHost = "https://pancakeswap.info/pool";

export default [
  {
    title: "BBBB/BUSD",
    temperature: 65,
    type: "busd",
    contractAddress: "0x3C5934e71e1ea0B206d525324998f8f0908f3D2B",
    minApr: 159,
    abi: bbbbBusdCakeLpFarmingPool.abi,
    url: `${host}/0x3C5934e71e1ea0B206d525324998f8f0908f3D2B`,
    swapUrl: `${swapHost}/BNB/0x0Af80145c7E50e5973dA3A5A174BF83A4ef94590`,
    pairUrl: `${pairHost}/0x55240e3f3e0746748bf8864e19b0ff4aaf717a4b`,
  },
];
